import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { usePersistedState } from './hooks/usePersistedState';
import SuccessScreen from './components/SuccessScreen';
import Login from './components/Login';
import Welcome from './pages/Welcome';
import './index.css';
import CommissionForm from './pages/Commission';
import EnrollForm from './pages/Enroll';
import { useFavicon } from './hooks/useLogo';

function ProtectedRoute({ isAuthenticated, children }) {
  const location = useLocation();
  return isAuthenticated ? children : <Navigate to="/login" state={{ from: location }} replace />;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => localStorage.getItem('isAuthenticated') === 'true');

  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    setIsAuthenticated(storedAuth === 'true');
  }, []);

  useEffect(() => {
    const favicon = useFavicon();
    const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = favicon;
    document.head.appendChild(link);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={setIsAuthenticated} />} />
        <Route path="/" element={<Navigate to="/welcome" replace />} />
        <Route path="/welcome" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Welcome /></ProtectedRoute>} />
        <Route path="/enroll" element={<ProtectedRoute isAuthenticated={isAuthenticated}><EnrollForm /></ProtectedRoute>} />
        <Route path="/commission" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CommissionForm /></ProtectedRoute>} />
        <Route path="/success" element={<ProtectedRoute isAuthenticated={isAuthenticated}><SuccessScreen /></ProtectedRoute>} />

      </Routes>
    </Router>
  );
}

export default App;